"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CancellationTokenSource = /** @class */ (function () {
    function CancellationTokenSource() {
        var _this = this;
        this._registeredCancelActions = [];
        this._linkedTokenUnregisterCallbacks = [];
        this._isCanceled = false;
        this._isDisposed = false;
        var isCanceled = function () { return _this._isCanceled; };
        this._token = {
            get isCancellationRequested() {
                return isCanceled();
            },
            throwIfCancellationRequested: function () {
                if (isCanceled()) {
                    throw new Error('canceled');
                }
            },
            register: function (callback) {
                if (typeof callback !== 'function') {
                    throw new Error('The registered callback must be a function.');
                }
                if (isCanceled()) {
                    callback();
                    return function () { };
                }
                _this._registeredCancelActions = _this._registeredCancelActions.concat([callback]);
                return function () {
                    _this._registeredCancelActions = _this._registeredCancelActions.filter(function (x) { return x !== callback; });
                };
            },
        };
    }
    CancellationTokenSource.createLinkedTokenSource = function () {
        var tokens = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tokens[_i] = arguments[_i];
        }
        var linkedTokenSource = new CancellationTokenSource();
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (token.isCancellationRequested) {
                linkedTokenSource.cancel();
                break;
            }
            var unregister = token.register(function () { return linkedTokenSource.cancel(); });
            linkedTokenSource._linkedTokenUnregisterCallbacks.push(unregister);
        }
        return linkedTokenSource;
    };
    Object.defineProperty(CancellationTokenSource.prototype, "token", {
        get: function () {
            this.assertNotDisposed();
            return this._token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CancellationTokenSource.prototype, "isCancellationRequested", {
        get: function () {
            return this._isCanceled;
        },
        enumerable: true,
        configurable: true
    });
    CancellationTokenSource.prototype.cancel = function () {
        this.assertNotDisposed();
        this._isCanceled = true;
        this._registeredCancelActions.forEach(function (cancelAction) { return cancelAction(); });
        this._linkedTokenUnregisterCallbacks.forEach(function (unregister) { return unregister(); });
        this._registeredCancelActions = [];
        this._linkedTokenUnregisterCallbacks = [];
    };
    CancellationTokenSource.prototype.dispose = function () {
        this._isDisposed = true;
        this._token = null;
        this._linkedTokenUnregisterCallbacks.forEach(function (unregister) { return unregister(); });
        this._registeredCancelActions = [];
        this._linkedTokenUnregisterCallbacks = [];
    };
    CancellationTokenSource.prototype.assertNotDisposed = function () {
        if (this._isDisposed) {
            throw new Error('Using the CancellationTokenSource after disposal is prohibited.');
        }
    };
    return CancellationTokenSource;
}());
exports.CancellationTokenSource = CancellationTokenSource;
